import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function BrushIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="m10.93 8.75-1.12 1.37 12.07 12.06 1.37-1.12-12.32-12.3Zm19.81 4.94-7.46-7.46a.87.87 0 0 0-.9-.21l-2.06.68.69-2.06a.88.88 0 0 0-.21-.9l-2.5-2.48a.88.88 0 0 0-1.3.06l-4.96 6.06L24.6 19.95l6.07-4.96c.4-.33.43-.94.06-1.3Zm-22.1-2.18-.84 1.03a4.38 4.38 0 0 0 .3 5.89l.76.76-6.18 4.63C.85 25.2.4 27.86 1.89 29.62a3.93 3.93 0 0 0 6.14-.2l4.75-6.31.76.76a4.38 4.38 0 0 0 5.89.3l1.02-.84L8.64 11.5ZM5.22 27.62a.88.88 0 1 1 0-1.76.88.88 0 0 1 0 1.76Z"
      />
    </BaseIcon>
  );
}
